import React from 'react';
import {utils} from '../../utils'
import {itemActions} from '../../utils'
import {versionManager} from '../../versioning/proGalleryVersionManager.js';

class FullscreenShareButtons extends React.Component {
  constructor(props) {
    super(props);

    this.buttons = [];
  }

  componentDidUpdate() {

    if (!utils.isAccessibilityEnabled()) {
      return;
    }

    try {
      let focusedButton = this.props.focus;
      if (focusedButton > 0) {
        // this.buttonsContainer.focus();
        this.buttons[focusedButton - 1].focus();
      }

    } catch (e) {
      console.warn('Cannot focus on share icon', this.props.focus, e);
    }
  }

  render() {
    let isNewMobileFullscreenLayout = versionManager.useFullscreenNewMobileLayout() && utils.isMobile();
    var shareArr = ['facebook', 'twitter', 'pinterest', 'tumblr', 'email'];
    if (this.props.item.type == 'text') {
      shareArr.splice(2, 1);
    }

    var buttons = shareArr.map(
      (network, idx) => {
        // let networkName = network.capitalize()
        let networkName = network.charAt(0).toUpperCase() + network.slice(1).toLowerCase()
        return isNewMobileFullscreenLayout ? (
          <div className="fullscreen-social-item-container">
            <div className="fullscreen-social-item"
                 onClick={() => itemActions.share(network, this.props.item, 'fullscreen')}>
              <div className={"fullscreen-social-" + network + " progallery-svg-font-icons-" + network}
                   key={network + "-share-icon"}
                   data-hook={network + "-share-hook"}/>
              <div className="network-name">{networkName}</div>
            </div>
          </div>
        ) : (
          <button
            className={"fullscreen-social-" + network + " progallery-svg-font-icons-" + network}
            ref={button => this.buttons[idx] = button}
            onClick={() => itemActions.share(network, this.props.item, 'fullscreen')}
            key={network + "-share-icon"}
            data-hook={network + "-share-hook"}
            title={`Share on ${network}`}
            aria-label={`Share on ${network}, ${idx} of 5`}
            aria-live="assertive"
            role="button"
            tabIndex={-1}
          />
        );
      }
    );

    return (
      <div className="fullscreen-social-items-container"
           aria-live="assertive"
           ref={ele => this.buttonsContainer = ele}
           tabIndex={-1}
      >{buttons}</div>
    )
  }

}

export default FullscreenShareButtons;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenShareButtons.js